import React from "react";

function DashboardStatus({ topLocales = [], topCategorias = [] }) {
    const maxLocalMonto = topLocales.length > 0
        ? Math.max(...topLocales.map((item) => Number(item?.monto_total_movimientos) || 0))
        : 0;

    const maxCategoriaMonto = topCategorias.length > 0
        ? Math.max(...topCategorias.map((item) => Number(item?.monto_total_movimientos) || 0))
        : 0;

    return (
        <section className="space-y-6">
            <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
                <div className="rounded-xl border border-gray-200 bg-white shadow-sm">
                    <div className="border-b border-gray-100 px-4 py-3">
                        <h3 className="text-lg font-semibold text-gray-900">Top locales</h3>
                        <p className="text-xs text-gray-500">Ranking por monto total de movimientos.</p>
                    </div>

                    <div className="max-h-[480px] overflow-y-auto px-4 py-3 space-y-3">
                        {topLocales.length === 0 ? (
                            <p className="rounded-lg border border-dashed border-gray-300 bg-gray-50 p-3 text-sm text-gray-500">
                                No hay datos de locales para mostrar.
                            </p>
                        ) : (
                            topLocales.map((item, index) => {
                                const rawValue = Number(item?.monto_total_movimientos) || 0;
                                const width = maxLocalMonto > 0 ? (rawValue / maxLocalMonto) * 100 : 0;

                                return (
                                    <div key={`${item?.local_id || index}-${index}`} className="rounded-lg border border-gray-200 bg-gray-50 p-3">
                                        <div className="flex items-start justify-between gap-3">
                                            <div>
                                                <p className="text-sm font-semibold text-gray-900">
                                                    {index + 1}. {item?.local_nombre || "-"}
                                                </p>
                                                <p className="text-xs text-gray-500">{item?.categoria_nombre || "Sin categoria"}</p>
                                            </div>
                                            <span className="rounded-full bg-white border border-gray-200 px-2 py-1 text-xs font-medium text-gray-600">
                                                {item?.cantidad_movimientos || 0} mov.
                                            </span>
                                        </div>

                                        <div className="mt-3 h-2 w-full rounded-full bg-gray-200">
                                            <div className="h-2 rounded-full bg-blue-500" style={{ width: `${Math.min(100, width)}%` }} />
                                        </div>

                                        <div className="mt-2 flex flex-wrap items-center justify-between gap-2 text-xs text-gray-600">
                                            <span>{item?.monto_total_movimientos_format || "Gs. 0"}</span>
                                            <span>{item?.clientes_unicos_total || 0} clientes</span>
                                        </div>
                                    </div>
                                );
                            })
                        )}
                    </div>
                </div>

                <div className="rounded-xl border border-gray-200 bg-white shadow-sm">
                    <div className="border-b border-gray-100 px-4 py-3">
                        <h3 className="text-lg font-semibold text-gray-900">Top categorias</h3>
                        <p className="text-xs text-gray-500">Rendimiento por categoria en el periodo.</p>
                    </div>

                    <div className="max-h-[480px] overflow-y-auto px-4 py-3 space-y-3">
                        {topCategorias.length === 0 ? (
                            <p className="rounded-lg border border-dashed border-gray-300 bg-gray-50 p-3 text-sm text-gray-500">
                                No hay datos de categorias para mostrar.
                            </p>
                        ) : (
                            topCategorias.map((item, index) => {
                                const rawValue = Number(item?.monto_total_movimientos) || 0;
                                const width = maxCategoriaMonto > 0 ? (rawValue / maxCategoriaMonto) * 100 : 0;

                                return (
                                    <div key={`${item?.categoria_id || index}-${index}`} className="rounded-lg border border-gray-200 bg-gray-50 p-3">
                                        <div className="flex items-start justify-between gap-3">
                                            <div>
                                                <p className="text-sm font-semibold text-gray-900">
                                                    {index + 1}. {item?.categoria_nombre || "-"}
                                                </p>
                                                <p className="text-xs text-gray-500">{item?.locales_unicos_total || 0} locales unicos</p>
                                            </div>
                                            <span className="rounded-full bg-white border border-gray-200 px-2 py-1 text-xs font-medium text-gray-600">
                                                {item?.cantidad_movimientos || 0} mov.
                                            </span>
                                        </div>

                                        <div className="mt-3 h-2 w-full rounded-full bg-gray-200">
                                            <div className="h-2 rounded-full bg-emerald-500" style={{ width: `${Math.min(100, width)}%` }} />
                                        </div>

                                        <div className="mt-2 flex flex-wrap items-center justify-between gap-2 text-xs text-gray-600">
                                            <span>{item?.monto_total_movimientos_format || "Gs. 0"}</span>
                                            <span>{item?.clientes_unicos_total || 0} clientes</span>
                                        </div>
                                    </div>
                                );
                            })
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default DashboardStatus;
